import React from 'react';
import ReactDOM from 'react-dom';

import Newsletter from '../Containers/Newsletter'


const news = document.getElementById('newsletter')
const NewsTitle = JSON.parse(news.getAttribute('data-info'))
ReactDOM.render(<Newsletter {...NewsTitle} />, news);


// WEBPACK FOOTER //
// ./src/build/newsletter.js